<div class="part-description pb-1">{{part.Description}}</div>
<div class="part-item-number pb-1">{{part.Brand}} - <app-part-item-number-link [partItemNumber]="part.PartItemNumber" [shopKind]="shopKind"></app-part-item-number-link></div>
<app-catalog-parts-properties  
  [part]="part" 
  [partsProperties]="partsProperties" 
  [partsPropertyTranslations]="partsPropertyTranslations"
  [collapsedItemCount]="partsPropertyCollapsedItemCount" 
  [shopKind]="shopKind">
</app-catalog-parts-properties>
